import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/')({
  // staticData: {
  //   groupingRuleType: GroupingRuleSetTypes.Ticket,
  // },
  beforeLoad: ({ context, preload }) => {
    const {
      featureFlags,
      validatePermissions,
      userPermissions: { hasAllowedPermission },
    } = context;
    const isNewSeverityAndSLA = featureFlags[FeatureFlags.NewSeverityAndSLA];
    const isAllowed = hasAllowedPermission({ path: PAGE_PATHS.SEVERITY_SLA, app: APP_PATHS.VULNERABILITIES }) && !!isNewSeverityAndSLA;
    validatePermissions({ isAllowed, preload });
  },
});
